module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ls-theme-cyanogen container subscribe-wrapper"
  }, [_c('header', {
    staticClass: "main-header ls-md-margin-top"
  }, [_c('h1', {
    staticClass: "trade-name"
  }, [_vm._v(_vm._s(_vm.basicSeller.trade_name || _vm.basicSeller.name))]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('payments.messages.finalize_payment')))])]), _vm._v(" "), _c('flash-message', {
    staticClass: "container ls-sm-margin-top"
  }), _vm._v(" "), (_vm.choosePayment && _vm.invoiceIsValid) ? _c('choose-payment', {
    staticClass: "checkout-details col-md-12"
  }) : _vm._e(), _vm._v(" "), (_vm.card) ? _c('card') : _vm._e(), _vm._v(" "), (_vm.transfer) ? _c('transfer') : _vm._e(), _vm._v(" "), (_vm.checkoutYapay) ? _c('checkout-yapay') : _vm._e(), _vm._v(" "), (!_vm.choosePayment && _vm.canChangePayment) ? _c('p', {
    staticClass: "ls-text-sm ls-md-space ls-no-padding ls-md-margin-top"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.changePaymentMethod
    }
  }, [_vm._v(_vm._s(_vm.$t('payments.messages.change_method')))])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-214a7c19"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/payments/Main.vue
// module id = 740
// module chunks = 1